module.exports = new __parcel__URL__("dps_icon_small.5ce32a92.png").toString();